import React, { useCallback } from 'react'
import { IOpenPanel } from '../../../../Interfaces/IPanel'
import { IOperadorRequest } from '../../../../Interfaces/auxiliar/IOperador'
import { IComboBox, IComboBoxOption, Panel, PanelType } from '@fluentui/react'
import { PanelHeader } from '../../../../components/Panel/PanelHeader'
import { PanelFooter } from '../../../../components/Panel/PanelFooter'

export interface IPanelOperador extends IOpenPanel {
    // filtro: IOperadorRequest
    // setFiltro: React.Dispatch<React.SetStateAction<IOperadorRequest>>
    equipoAuxiliar?: boolean
}

const PanelOperadorFiltro = (props: IPanelOperador) => {

    const onChangeCombo = (
        event: React.FormEvent<IComboBox>,
        option?: IComboBoxOption,
        nombre?: string
    ) => {
        /* if (event !== undefined) {
            if (option) {
                switch (nombre) {
                    case "razon":
                        setFilter({
                            ...filter,
                            razonId: option.key.toString(),
                        });
                        break;
                    case "turno":
                        setFilter({
                            ...filter,
                            turnoId: option.key.toString(),
                        });
                        break;
                    case "ubicacion":
                        setFilter({
                            ...filter,
                            ubicacionId: option.key.toString(),
                        });
                        break;
                    case "equipo":
                        setFilter({
                            ...filter,
                            equipoId: option.key.toString(),
                        });
                        break;
                    default:
                        break;
                }
            }
        } */
    };

    const onRenderHeader = useCallback(() => (
        <>
            <PanelHeader
                textHeader={`Operadores`}
                subTextHeader={`Filtro de Operadores`}
            />
        </>
    ), []);

    const onRenderFooter = useCallback(() => (
        <>
            <PanelFooter
                texto="Filtrar"
                texto2={"Salir"}
                onClick={() => { }/* filtrar */}
                disableButton={false}
                onDismiss={() => { props.onDismiss() }}
            />
        </>
    ), []);

    return (
        <>
            <Panel
                type={PanelType.smallFixedFar}
                onRenderHeader={onRenderHeader}
                onRenderFooter={onRenderFooter}
                isFooterAtBottom
                isOpen={props.isOpen}
                onDismiss={() => { props.onDismiss() }}
            >

            </Panel>
        </>
    )
}

export { PanelOperadorFiltro }